import { Component, OnInit, Input } from '@angular/core';
import { IReceivedPaymentInfo } from '../../../common/interface/iReceivedPaymentInfo';

@Component({
  selector: 'payment-form-subhead',
  templateUrl: './payment.form.subhead.component.html',
})
export class PaymentFormSubheadComponent implements OnInit {
  @Input() formType: string;
  @Input() receivedPaymentInfo: IReceivedPaymentInfo;

  frequency: string = '';

  constructor() {}

  ngOnInit() {
    this.frequency = this.getFrequencyText();
  }

  getFrequencyText(): string {
    if (this.receivedPaymentInfo.frequency === 'Monthly') {
      return 'month';
    }
    if (this.receivedPaymentInfo.frequency === 'Annual') {
      return 'year';
    }
    return '';
  }
}
